// utils/cryptoHelpers.js
import CryptoJS from 'crypto-js';

const SECRET_KEY = `${process.env.NEXT_PUBLIC_APP_CRYPTO}${process.env.NEXT_PUBLIC_KEY}`;

export const encryptData = (data) => {
  const stringData = data && JSON.stringify(data);
  return stringData && CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
};

export const decryptData = (encryptedData) => {
  const bytes = encryptedData && CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
  const decryptedString = bytes?.toString(CryptoJS.enc.Utf8);
  return decryptedString && JSON.parse(decryptedString);
};
